import { combineEpics } from 'redux-observable';
import type { Action } from '../state/actions.tsx';
import type { State } from '../state/reducer.tsx';
import createComponent from './create.tsx';
import { successfulDelete } from './delete.tsx';
import { queryPatched } from './query-patched.tsx';
import { querySet } from './query-set.tsx';
import { retrieveComponents } from './retrieve.tsx';
import { updateComponent, initiateUpdateComponent } from './update.tsx';

export default combineEpics<Action, State>(
	retrieveComponents,
	createComponent,
	updateComponent,
	initiateUpdateComponent,
	successfulDelete,
	querySet,
	queryPatched,
);
